(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-quantity-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-quantity-input]');
      var dec = stepper.querySelector('[data-quantity-decrement]');
      var inc = stepper.querySelector('[data-quantity-increment]');
      if (!input) return;

      function set(val) {
        var n = parseInt(val, 10);
        if (isNaN(n) || n < 1) n = 1;
        input.value = n;
      }

      if (dec) dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      if (inc) inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { set(input.value); });
    });

    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var form = btn.closest('form') || document.querySelector('[data-product-form]');
        if (!form) return;
        var data = new FormData(form);
        btn.disabled = true;
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/javascript' }
        }).then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          btn.disabled = false;
          form.submit();
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      var elements = root.querySelectorAll('[data-product-description]');
      elements.forEach(function (el) {
        if (el.dataset.initialized === 'true') return;
        el.dataset.initialized = 'true';

        var content = el.querySelector('[data-product-description-content]');
        var button = el.querySelector('[data-product-description-toggle]');
        var label = el.querySelector('[data-product-description-toggle-label]');
        if (!content || !button || !label) return;

        var expandText = el.dataset.expandText || 'Ver más';
        var reduceText = el.dataset.reduceText || 'Ver menos';

        function applyState() {
          var overflows = content.scrollHeight > content.clientHeight + 1;
          if (!overflows && !el.classList.contains('product-page__description--expanded')) {
            button.classList.add('product-description__toggle--hidden');
            el.classList.remove('product-page__description--collapsed');
            return;
          }
          button.classList.remove('product-description__toggle--hidden');
        }

        el.classList.add('product-page__description--collapsed');
        label.textContent = expandText;
        requestAnimationFrame(applyState);

        button.addEventListener('click', function () {
          var expanded = el.classList.toggle('product-page__description--expanded');
          el.classList.toggle('product-page__description--collapsed', !expanded);
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          label.textContent = expanded ? reduceText : expandText;
        });

        window.addEventListener('resize', applyState);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:block:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
